import angular from 'angular';
import FileController from './file.controller';

export const FileComponent = {
  selector: 'file',
  bindings: {
    file: '=?',
    fileId: '=?',
    disableDelete: '@?',
  },
  controller: FileController,
  template: /* html */ `
    <div class="file-card">
      <ab-card
        classes="filled"
        title-icon="file"
        title="{{ $ctrl.file.type}}"
        subtitle="{{ $ctrl.file.upload_date | date : 'dd. MMMM yyyy HH:mm' : '+CET' }} von {{ $ctrl.uploaderName }}"
      >
        <div class="btn-wrap left" ng-init="$ctrl.deleteSecondStep = false">
          <button type="button" class="btn-lvl1" permission="0,4,6,7" ng-show="!$ctrl.deleteSecondStep" ng-click="$ctrl.downloadFile($ctrl.file.id, $ctrl.file.name)">
            <svg class="ab-icon"><use xlink:href="#btn-download"></use></svg> Download</button>
          <button type="button" class="btn-lvl3" ng-click="$ctrl.deleteSecondStep = true" ng-if="!$ctrl.disableDelete" ng-show="!$ctrl.deleteSecondStep" permission="0,4,6,7">
            <svg class="ab-icon"><use xlink:href="#btn-delete"></use></svg>
          </button>

          <button type="button" class="btn-lvl1 danger" ng-show="$ctrl.deleteSecondStep" ng-click="$ctrl.deleteFile($ctrl.file.id)">Wirklich Löschen</button>
          <button type="button" class="btn-lvl1" ng-show="$ctrl.deleteSecondStep" ng-click="$ctrl.deleteSecondStep = false">Abbrechen</button>
        </div>
      </ab-card>
    </div>
  `,
};

export default angular.module('directives.abFile', [])
  .component(FileComponent.selector, FileComponent)
  .name;
